module.exports = __webpack_public_path__ + "static/homepage-desktop-coast-23835976d5519cb86c522298ed900ee1.jpg";